import PausePresentationIcon from '@mui/icons-material/PausePresentation';
import BugReportIcon from '@mui/icons-material/BugReport';
import InfoIcon from '@mui/icons-material/Info';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CommentIcon from '@mui/icons-material/Comment';
import Tooltip, {TooltipProps, tooltipClasses} from '@mui/material/Tooltip';
import {styled} from '@mui/material/styles';
import DialogComment from "../_subcomponents/DialogComment";
import DialogPark from "../_subcomponents/DialogPark";
import DialogInfo from "../_subcomponents/DialogInfo";
import DialogDeleteMap from "../_subcomponents/DialogDeleteMap";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


// Customization of the ToolTip backgroundColor and fontSize
export const LightTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#8c8c8c',    // theme.palette.info.dark,
        // color: 'rgba(0, 0, 0, 0.87)',
        color: 'rgba(255, 255, 255, 1)',
        boxShadow: theme.shadows[1],
        fontSize: 10,
        fontWeight: 300
    },
}));


export default function MapToolsBase(props: any) {
    let {user, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    let {keyDataSet, mapInfo, setMapInfo, featDefmapStatus, setSaveStatus} = props

    const [comOpen, setComOpen] = useState(false);

    const [parkOpen, setParkOpen] = useState(false);

    const [infoOpen, setInfoOpen] = useState(false);

    const [deleteOpen, setDeleteOpen] = useState(false);

    //    const handleIconClicks = (name:any) => () => {
    //     console.log(name);
    // }

    function handleUnpark() {
        fetch(`${serverIP}/unparkmap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({...keyDataSet, user: user.username}),
        }).then(res => res.json())
            .then((data) => {
                if (data.code === 200) {
                    setMapInfo((prevState: any) => {
                        return {...prevState, mapStatus: '', mapRemark: ''}
                    })
                    // console.log('Success')
                }
                // console.log(data)
            })
    }

    return (
        <>
            {/* Comment */}
            <DialogComment
                open={comOpen}
                setOpen={setComOpen}
                keyDataSet={keyDataSet}
                comment={mapInfo.mapRemark}
                setMapInfo={setMapInfo}
            />
            <LightTooltip title="Add comment">
                <CommentIcon
                    color="action"
                    className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                    onClick={userPermissions.canEdit ? () => setComOpen(true) : undefined}
                />
            </LightTooltip>


            {/* Park mapping */}
            <DialogPark
                open={parkOpen}
                setOpen={setParkOpen}
                keyDataSet={keyDataSet}
                setMapInfo={setMapInfo}
            />
            {mapInfo?.mapStatus === 'parked' ?
                <LightTooltip title="Unpark (resume) Mapping">
                    <PlayCircleOutlineIcon
                        color="primary"
                        className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                        onClick={userPermissions.canEdit ? handleUnpark : undefined}
                    />
                </LightTooltip>
                :
                <LightTooltip title="Park Mapping">
                    <PausePresentationIcon
                        color="action"
                        className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                        onClick={userPermissions.canEdit ? () => setParkOpen(true) : undefined}
                        // onClick={() => handleIconClicks('park')}
                    />
                </LightTooltip>
            }

            {/* Delete mapping. !Condition for FeatMap only! */}
            {featDefmapStatus !== 'isDefMapUsed' &&
                <>
                    <DialogDeleteMap
                        open={deleteOpen}
                        setOpen={setDeleteOpen}
                        keyDataSet={keyDataSet}
                        setSaveStatus={setSaveStatus}
                        // setMapInfo={setMapInfo}
                        // setCondObject={setCondObject}
                        // initialObjEmpty={initialObjEmpty}
                    />
                    <LightTooltip title="Delete Mapping">
                        <DeleteOutlineIcon
                            color="action"
                            className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                            onClick={userPermissions.canEdit ? () => setDeleteOpen(true) : undefined  }
                        />
                    </LightTooltip>
                </>
            }


            {/* Test mapping */}
            {/*<LightTooltip title="Test mapping">*/}
            {/*    <BugReportIcon color="action" className="icon-clickable"/>*/}
            {/*</LightTooltip>*/}


            {/* Mapping Info */}
            <DialogInfo
                open={infoOpen}
                setOpen={setInfoOpen}
                mapInfo={mapInfo}
            />
            <LightTooltip title="Mapping Info">
                <InfoIcon
                    color="action"
                    className="icon-clickable"
                    onClick={() => setInfoOpen(true)}
                    // onMouseOver={handleInfoClick}
                />
            </LightTooltip>

        </>
    )
}